export default "__VITE_ASSET__DF3AsfvN__"